<template>
  <j-select-biz-component :width="1200" v-bind="configs" v-on="$listeners" />
</template>

<script>
  import JSelectBizComponent from './JSelectBizComponent'

  export default {
    name: 'JSelectDevice',
    components: { JSelectBizComponent },
    // props: ['value'],
    props: {
      value: null, // any type
      queryConfig: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        settings: {
          name: '设备',

          displayKey: 'devName',
          valueKey: 'id',
          returnKeys: ['id', 'devName'],
          listUrl: '/device/devList/list',
          // queryParamCode: 'devName',
          // queryParamText: '设备名称',

          columns: [
            { title: '设备名称', dataIndex: 'devName', align: 'center', sorter: true, width: '60%' },
            // devCode
            { title: '位号', dataIndex: 'devTag', align: 'center', sorter: true, width: '20%' },

            { title: '设备型号', dataIndex: 'typeName', align: 'center', width: '20%' }
            // { title: '工艺类型', dataIndex: 'processName', align: 'center', width: '35%' }
          ]
        },
        queryConfigDefault: [
          {
            key: 'devProcessId',
            label: '供水流域',
            // 如果包含 dictCode，那么就会显示成下拉框
            customRender: ({ key, queryParam, options }) => {
              return (
                <j-search-select-tag
                  dict="`iwt-wf`.dev_process,process_name,id"
                  onChange
                  {...options}
                  vModel={queryParam[key]}
                  style="width:180px;"
                />
              )
            }
          },
          {
            key: 'devName',
            label: '设备名称'
          }
        ]
      }
    },
    computed: {
      configs () {
        // return Object.assign({ value: this.value }, this.settings, this.$attrs)
        return Object.assign({ value: this.value }, this.settings, this.$attrs, {
          queryConfig: this.queryConfigDefault.concat(this.queryConfig),
          defaultParams: false,
          pageSize: 30,
          pageSizeOptions: [10, 30, 50]
        })
      }
    },
    methods: {
      selectChange (v) {
        this.$emit('select', v)
      }
    }
  }
</script>

<style lang="less" scoped></style>
